import { mayAutoRefresh, mayRefreshDisplay, watchBrowserActivity } from "./nightActivity.mjs";
// One automatic request at a time. Manual action refreshes are not delayed.
export function watchVisiblePolling(reload, intervalMs = 90000, {
  initial = true, document:doc = document, window:win = window,
  setInterval:setTimer = setInterval, clearInterval:clearTimer = clearInterval,
  pauseWhenIdle = false,
  canRefresh = pauseWhenIdle ? mayRefreshDisplay : mayAutoRefresh, watchActivity = watchBrowserActivity,
} = {}) {
  let stopped = false;
  let pending = false;
  const refresh = async () => {
    if (stopped || pending || doc.visibilityState === "hidden" || !canRefresh()) return;
    pending = true;
    try { await reload(); } catch { /* The caller owns error presentation. */ }
    finally { pending = false; }
  };
  const timer = setTimer(refresh, intervalMs);
  doc.addEventListener("visibilitychange", refresh);
  win.addEventListener("focus", refresh);
  const unwatchActivity = watchActivity(refresh);
  if (initial) void refresh();
  return () => {
    stopped = true;
    clearTimer(timer);
    unwatchActivity();
    doc.removeEventListener("visibilitychange", refresh);
    win.removeEventListener("focus", refresh);
  };
}
